"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonsMainImage = void 0;
var _react = _interopRequireDefault(require("react"));
require("../../styles/gallery.css");
var _box = require("@oneloop/box");
var _ButtonGallery = require("./ButtonGallery");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ButtonsMainImage = exports.ButtonsMainImage = function ButtonsMainImage(_ref) {
  var _ref$video = _ref.video,
    video = _ref$video === void 0 ? [] : _ref$video,
    _ref$video2 = _ref.video360,
    video360 = _ref$video2 === void 0 ? [] : _ref$video2,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images,
    _ref$imgWithCover = _ref.imgWithCover,
    imgWithCover = _ref$imgWithCover === void 0 ? [] : _ref$imgWithCover,
    _ref$planos = _ref.planos,
    planos = _ref$planos === void 0 ? [] : _ref$planos,
    _ref$frontCoverBluepr = _ref.frontCoverBlueprints,
    frontCoverBlueprints = _ref$frontCoverBluepr === void 0 ? [] : _ref$frontCoverBluepr,
    setTabSelected = _ref.setTabSelected,
    setFullscreen = _ref.setFullscreen,
    setIndex = _ref.setIndex,
    tabTextsDict = _ref.tabTextsDict;
  var handleClick = function handleClick(e, type) {
    e.stopPropagation();
    setTabSelected(type);
    setFullscreen(true);
    setIndex(0);
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "buttonsMainImgContainer"
  }, video.length > 0 && /*#__PURE__*/_react["default"].createElement(_ButtonGallery.ButtonGallery, {
    text: tabTextsDict.videos,
    onClick: function onClick(e) {
      handleClick(e, 'videos');
    }
  }), video360.length > 0 && /*#__PURE__*/_react["default"].createElement(_ButtonGallery.ButtonGallery, {
    text: tabTextsDict.video360,
    onClick: function onClick(e) {
      handleClick(e, 'video360');
    }
  }), (images.length > 0 || imgWithCover.length > 0) && /*#__PURE__*/_react["default"].createElement(_ButtonGallery.ButtonGallery, {
    className: "buttonGallery",
    text: tabTextsDict.photos,
    onClick: function onClick(e) {
      handleClick(e, 'fotos');
    }
  }), (planos.length > 0 || frontCoverBlueprints.length > 0) && /*#__PURE__*/_react["default"].createElement(_ButtonGallery.ButtonGallery, {
    text: tabTextsDict.bluePrints,
    onClick: function onClick(e) {
      handleClick(e, 'planos');
    }
  }));
};